import { useEffect, useState } from "react";
import styles from "./CookieBanner.module.scss";
import ArrowIcon from "../../../assets/images/icons/arrow-left.svg";
import RoundedIcon from "./arrow.svg";

import { getCookieConsent, setCookieConsent } from "../../../lib/cookie/cookie";
import { routes } from "../../../router/routes";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getCookieConsent();

    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookieConsent("accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    setCookieConsent("declined");
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.cookieBanner}>
      <div className={styles.content}>
        <p className={styles.text}>
          Используем cookie для работы сайта, аналитики и персонализации
          рекламы. Вы можете выбрать, какие категории cookie разрешить.
        </p>

        <div className={styles.detailsBtn}>
          <a className={styles.btnText} href={routes.cookiePolicy}>
            Подробнее
          </a>

          <img src={ArrowIcon} alt="" className={styles.icon} />
        </div>

        <div className={styles.btns}>
          <button className={styles.accept} onClick={handleAccept}>
            <img src={RoundedIcon} alt="" className={styles.icon} />

            <p className={styles.text}>Принять</p>
          </button>

          <button className={styles.decline} onClick={handleDecline}>
            Отклонить необязательные
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
